module.exports = __webpack_public_path__ + "img/54.31a4c98e.jpg";